import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!

  return (_openBlock(), _createBlock(_component_el_dropdown_item, {
    style: { color: '#f56c6c' },
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteRecord(_ctx.id)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Icon, { icon: "ic:baseline-delete-forever" }),
      _createElementVNode("span", null, _toDisplayString(_ctx.trans("label.delete")), 1)
    ]),
    _: 1
  }))
}